module.exports = __webpack_public_path__ + "img/fruit-cantaloupe-350x184.3beb1a00.jpg";